import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Box, DownloadFile, Icon, InputWithIcon, PrintFile } from '@livable/saas-react-components';
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import useStyles from './styles';
import { useStore } from 'src/stores';
export const AddendumsFilesPage = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const history = useLocation();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const address = history.state.address;
  const propertyId = new URLSearchParams(history.search).get('id');
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    residentsData = _useState2[0],
    setResidentsData = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
  };
  const breadcrumbArray = [{
    title: t('file_cabinet.files'),
    link: '/file_cabinet'
  }, {
    title: t('file_cabinet.resident_addenda'),
    link: '/file_cabinet',
    tab: 'addendums'
  }, {
    title: address
  }];
  const _useState5 = useState('all'),
    _useState6 = _slicedToArray(_useState5, 2),
    residents = _useState6[0],
    setResidents = _useState6[1];
  const handleResidentsChange = (e, value) => {
    if (value) setResidents(value);
  };
  const _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    startDateRange = _useState8[0],
    setStartDateRange = _useState8[1];
  const _useState9 = useState(undefined),
    _useState0 = _slicedToArray(_useState9, 2),
    endDateRange = _useState0[0],
    setEndDateRange = _useState0[1];
  const handleDateRangeChange = _ref => {
    let startDate = _ref.startDate,
      endDate = _ref.endDate;
    setStartDateRange(moment(startDate));
    setEndDateRange(moment(endDate));
  };
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    residentFullNameSort = _useState10[0],
    setResidentFullNameSort = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    residentUnitNameSort = _useState12[0],
    setResidentUnitNameSort = _useState12[1];
  const fetchPropertyResidentsAddendums = async () => {
    const result = await store.residencies.getPropertyResidentsAddendumsV2Async.run({
      propertyId
    });
    if (result !== null && result !== void 0 && result.isSuccessful) {
      const propertyResidentsAddendumsList = result.response;
      const accountIds = propertyResidentsAddendumsList.map(i => i.accountId);
      const accountIdsResp = await store.account.getUsersProfilesAsync.run({
        accountIds
      });
      if (accountIdsResp !== null && accountIdsResp !== void 0 && accountIdsResp.isSuccessful) {
        accountIdsResp.response.map(accountItem => {
          const matchingIndex = propertyResidentsAddendumsList.findIndex(fItem => fItem.accountId === accountItem.id);
          propertyResidentsAddendumsList[matchingIndex].fullName = "".concat(accountItem.firstName, " ").concat(accountItem.lastName);
          propertyResidentsAddendumsList[matchingIndex].status = RESIDENCY_STATUS_KEY_VALUES[propertyResidentsAddendumsList[matchingIndex].residencyStatus];
        });
        setResidentsData(propertyResidentsAddendumsList);
      }
    }
  };
  const getFilteredData = () => {
    return residentsData.sort((a, b) => {
      if (residentFullNameSort === 'asc') {
        return a.fullName.localeCompare(b.fullName);
      }
      if (residentFullNameSort === 'desc') {
        return b.fullName.localeCompare(a.fullName);
      }
      if (residentUnitNameSort === 'asc') {
        return a.unitName.localeCompare(b.unitName);
      }
      if (residentUnitNameSort === 'desc') {
        return b.unitName.localeCompare(a.unitName);
      }
    }).filter(i => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(i.fullName).search(searchPhrase) > 0 || " ".concat(i.unitName).search(searchPhrase) > 0 : true;
    }).filter(i => {
      const leaseStartDate = i.leaseStartDateOnly === '0001-01-01' || i.leaseStartDateOnly === null || i.leaseStartDateOnly === 'null' ? null : moment(i.leaseStartDateOnly);
      const leaseEndDate = moment(i.leaseEndDateOnly);
      if (startDateRange || endDateRange) {
        return leaseStartDate.isBetween(startDateRange.startOf('day'), endDateRange === null || endDateRange === void 0 ? void 0 : endDateRange.endOf('day'), null, []) || leaseEndDate.isBetween(startDateRange.startOf('day'), endDateRange === null || endDateRange === void 0 ? void 0 : endDateRange.endOf('day'), null, []);
      } else {
        return true;
      }
    }).filter(i => {
      if (residents === 'active') {
        return i.residencyStatus === RESIDENCY_STATUS_KEY_VALUES.Future || i.residencyStatus === RESIDENCY_STATUS_KEY_VALUES.Current;
      } else if (residents === 'inactive') {
        return i.residencyStatus === RESIDENCY_STATUS_KEY_VALUES.FormerClosed || i.residencyStatus === RESIDENCY_STATUS_KEY_VALUES.FormerActive;
      } else {
        return true;
      }
    });
  };
  useEffect(() => {
    try {
      fetchPropertyResidentsAddendums();
    } catch (e) {
      console.log('useEffect Error', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbArray
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filtersWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchWrapper
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "tenants-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(RangeDatePicker, {
    handleDateChange: handleDateRangeChange
  }), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: residents,
    onChange: handleResidentsChange,
    className: classes.togglers,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "all"
  }, t('file_cabinet.show_all_residents')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "active"
  }, t('file_cabinet.active_residents')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "inactive"
  }, t('file_cabinet.former_residents')))), !!residentsData.length && !!getFilteredData().length && /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "addendums files table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.clickableCell,
    onClick: () => {
      setResidentUnitNameSort('');
      if (residentFullNameSort === '') {
        setResidentFullNameSort('asc');
      } else if (residentFullNameSort === 'asc') {
        setResidentFullNameSort('desc');
      } else {
        setResidentFullNameSort('');
      }
    }
  }, "".concat(t('file_cabinet.resident'), " ").concat(residentFullNameSort === 'asc' ? '↓' : residentFullNameSort === 'desc' ? '↑' : '↑↓')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.statusCell
  }, t('file_cabinet.status')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.clickableCell,
    onClick: () => {
      setResidentFullNameSort('');
      if (residentUnitNameSort === '') {
        setResidentUnitNameSort('asc');
      } else if (residentUnitNameSort === 'asc') {
        setResidentUnitNameSort('desc');
      } else {
        setResidentUnitNameSort('');
      }
    }
  }, "".concat(t('file_cabinet.unit'), " ").concat(residentUnitNameSort === 'asc' ? '↓' : residentUnitNameSort === 'desc' ? '↑' : '↑↓')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.periodCell
  }, t('file_cabinet.lease_period')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.actionCell
  }, t('file_cabinet.download')))), /*#__PURE__*/React.createElement(TableBody, null, !!getFilteredData().length && getFilteredData().map(resident => {
    var _store$files$getPresi, _store$fileCabinet$ge, _store$fileCabinet$ge2;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: resident.accountId
    }, /*#__PURE__*/React.createElement(TableCell, null, resident.fullName), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.statusCell
    }, resident.status), /*#__PURE__*/React.createElement(TableCell, null, resident.unitName), /*#__PURE__*/React.createElement(TableCell, null, "".concat(resident.leaseStartDateOnly === null ? 'Not set' : moment(resident.leaseStartDateOnly).format('MM/DD/YYYY'), " - ").concat(resident.leaseEndDateOnly ? moment(resident.leaseEndDateOnly).format('MM/DD/YYYY') : t('file_cabinet.current'))), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(PrintFile, {
      disabled: resident.leaseAddendumFileIds.length <= 0 || ((_store$files$getPresi = store.files.getPresignedFileDownloadUrlAsync) === null || _store$files$getPresi === void 0 ? void 0 : _store$files$getPresi.inProgress) || ((_store$fileCabinet$ge = store.fileCabinet.getPropertyBillsFileCabinetAsync) === null || _store$fileCabinet$ge === void 0 ? void 0 : _store$fileCabinet$ge.inProgress),
      fileId: resident.leaseAddendumFileIds[0],
      getUrlAsyncCallback: async () => {
        const resp = await store.files.getPresignedFileDownloadUrlAsync.run({
          fileId: resident.leaseAddendumFileIds[0],
          isPreview: true
        });
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          return resp.response;
        }
      },
      href: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? null : "".concat(store.files.getFilePreviewLink({
        fileId: resident.leaseAddendumFileIds[0]
      }))
    }), /*#__PURE__*/React.createElement(DownloadFile, {
      disabled: resident.leaseAddendumFileIds.length <= 0 || ((_store$fileCabinet$ge2 = store.fileCabinet.getPropertyBillsFileCabinetAsync) === null || _store$fileCabinet$ge2 === void 0 ? void 0 : _store$fileCabinet$ge2.inProgress),
      fileId: resident.leaseAddendumFileIds[0],
      usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
      store: store
    })));
  })))), !!residentsData.length && !getFilteredData().length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No Data Found"
  }), !residentsData.length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No Data Available"
  })))));
});